import { Dictionary } from 'lodash';

import {
  QuestionPerformanceType,
  QuestionType,
  QuizRevealAnswerEnum,
  TimeLimitApplicableOnEnum,
} from '@/types/schema';

import { ViewFields } from '../../../../../questions/fields/view';
import { QuestionPerformanceFragment } from '../../graphql/fragments/generated/QuestionPerformance';
import { QuizPerformanceFragment } from '../../graphql/fragments/generated/QuizPerformance';
import { QuizPlayerContentFragment } from '../../graphql/fragments/generated/QuizPlayerContent';
import { QuizPlayerQuestionContentFragment } from '../../graphql/fragments/generated/QuizPlayerQuestionContent';
import { QuestionView } from '../useQuizPlayer/types';

export const getIsTimedQuiz = (settings?: QuizPlayerContentFragment['settings']) =>
  !!settings?.timeLimit && !!settings.timeLimitApplicableOn;

export const getIsTimedQuestion = (settings?: QuizPlayerContentFragment['settings']) =>
  !!settings?.timeLimit && settings.timeLimitApplicableOn === TimeLimitApplicableOnEnum.Question;

export const getIsQuizSidebarEnabled = (settings?: QuizPlayerContentFragment['settings']) =>
  !getIsTimedQuestion(settings) && settings?.revealAnswers !== QuizRevealAnswerEnum.AfterQuestion;

export function getIsMissedQuestion(question: QuestionType, performance?: QuestionPerformanceType) {
  const { isValidSubmission } = ViewFields[question.questionType];
  return performance?.isSubmitted && !isValidSubmission(question, performance.submission);
}

export const getContentTimerDetails = (
  content: QuizPlayerContentFragment,
  view: QuestionView,
  questionPerformanceById: Dictionary<QuestionPerformanceFragment>,
  quizPerformance?: QuizPerformanceFragment,
) => {
  if (
    content.settings?.timeLimitApplicableOn === TimeLimitApplicableOnEnum.Quiz ||
    (view as QuestionView).index === 0
  ) {
    return {
      performance: quizPerformance,
    };
  }

  const questionId = (
    content.quizQuestionsConfig.questions[view.index] as QuizPlayerQuestionContentFragment
  ).id;
  return {
    performance: questionPerformanceById[questionId],
  };
};
